import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-00d89814"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container"
};
var _hoisted_2 = {
  class: "row"
};
var _hoisted_3 = {
  class: "col-md-8 long-left",
  id: "long-left"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "date"
};
var _hoisted_6 = {
  class: "col-md-4 long-right"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  class: "textarea"
};
var _hoisted_10 = {
  class: "date"
};
var _hoisted_11 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("blockquote", null, [_createElementVNode("h2", null, _toDisplayString($setup.newsdetail.title), 1)]), _createElementVNode("img", {
    src: $setup.newsdetail.imgUrl,
    alt: "新闻详情"
  }, null, 8, _hoisted_4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsdetail.content, function (c, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "content-list",
      key: c.contentId
    }, [_createElementVNode("h4", null, _toDisplayString(c.contentTitle), 1), _createElementVNode("p", null, _toDisplayString(c.contentText), 1)]);
  }), 128)), _createElementVNode("span", _hoisted_5, _toDisplayString($setup.newsdetail.releaseDate), 1)]), _createVNode(_Transition, {
    name: "newsRecommended",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__fadeInRight"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsRecommended, function (nr) {
        return _openBlock(), _createElementBlock("div", {
          class: "recommended",
          key: nr.id,
          onClick: function onClick($event) {
            return $setup.goRecommended(nr);
          }
        }, [_createElementVNode("img", {
          src: nr.imgUrl,
          alt: "公司新闻"
        }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(nr.releaseDate), 1), _createElementVNode("h3", _hoisted_11, _toDisplayString(nr.title), 1)])], 8, _hoisted_7);
      }), 128)), _createElementVNode("button", {
        class: "backList",
        onClick: _cache[0] || (_cache[0] = function () {
          return $setup.backNewsList && $setup.backNewsList.apply($setup, arguments);
        })
      }, "返回列表")])];
    }),
    _: 1
  })])]);
}